import { IPayerTaxFormResponse } from "@wingspanhq/payments/dist/interfaces";
import { selectorTaxFormIsInPostFilingState } from "./selectorTaxFormIsInPostFilingState";

export const selectorTaxFormIsEditable = (
  taxForm: IPayerTaxFormResponse
): boolean => !selectorTaxFormIsInPostFilingState(taxForm);
